import React, { useEffect, useState, useMemo } from 'react';
import './style/Catalog.css';
import CardProduct from './CardProduct';
import LocalDiningIcon from '@mui/icons-material/LocalDining';
import axios from 'axios';
import { PiCow } from "react-icons/pi";
import { GiSheep } from "react-icons/gi";
import { GiChickenOven } from "react-icons/gi";
import { TbMeat } from "react-icons/tb";
import { GiMeat } from "react-icons/gi";
import { LuMilk } from "react-icons/lu";
import { BiCheese } from "react-icons/bi";
import { GiButter } from "react-icons/gi";
import { FaCarrot } from "react-icons/fa";
import { useLocation, useNavigate } from 'react-router-dom';

const icons = {
  1: <GiSheep />,      // Баранина
  2: <GiChickenOven />,               // Курица и птица
  3: <TbMeat />,       // Мясные деликатесы
  4: <GiMeat />,      // Мясные субпродукты
  5: <PiCow />,      // Говядина
  6: <TbMeat />,       // Мясные закуски
  7: <LuMilk />,              // Молоко
  8: <BiCheese />,            // Сыры
  9: <GiButter />,               // Масло
  10: <FaCarrot />,            // Овощи
};

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function Catalog() {
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [products, setProducts] = useState([]);
  const query = useQuery();
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}v1/productCategories`, {
      headers: {
        'x-api-key': '12345xxa'
      }
    })
    .then(response => {
      setCategories(response.data);
    })
    .catch(error => {
      console.error('Error fetching categories:', error);
    });
  }, []);

  useEffect(() => {
    const categoryId = query.get('category');
    if (categoryId) {
      setSelectedCategory(categoryId);
      // Прокрутка страницы вверх при изменении категории
      window.scrollTo(0, 0);
    }
  }, [query]);

  useEffect(() => {
    if (selectedCategory) {
      axios.get(`${process.env.REACT_APP_API_URL}v1/products`, {
        headers: {
          'x-api-key': '12345xxa'
        }
      })
      .then(response => {
        const filteredProducts = response.data.filter(product => product.id_product_category === selectedCategory);
        setProducts(filteredProducts);
      })
      .catch(error => {
        console.error('Error fetching products:', error);
      });
    }
  }, [selectedCategory]);

  const handleCategoryClick = (categoryId) => {
    navigate(`/catalog?category=${categoryId}`);
  };

  const sidebar = useMemo(() => (
    <div className="catalog-sidebar">
      <div className="catalog-sidebar-content">
        <div className="catalog-sidebar-zagalovok">
          <h2 className="catalog-sidebar-zagalovok-1">
              Категории
          </h2>
        </div>
        <nav className="catalog-sidebar-navigation">
          <ul className="catalog-sidebar-nav-2">
            {categories.map(category => (
              <li key={category.id} className="catalog-sidebar-nav-3">
                {icons[category.id] || <LocalDiningIcon />}
                <button onClick={() => handleCategoryClick(category.id)} className="catalog-sidebar-nav-text">
                  {category.name}
                </button>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </div>
  ), [categories]);

  return (
    <div className="catalog-content">
      {sidebar}
      <div className="catalog-content-basic">
        <div className="catalog-content-block-1">
          <span className="catalog-content-text">
            <a href="/">Главная</a>
          </span>
          <span className="catalog-content-text">
            &gt;
          </span>
          <span className="catalog-content-text">
            <a href="./Catalog">Категории</a>
          </span>
          {selectedCategory && (
            <>
              <span className="catalog-content-text">
                &gt;
              </span>
              <span className="catalog-content-text">
                <a href={`/catalog?category=${selectedCategory}`}>
                  {categories.find(cat => cat.id === selectedCategory)?.name}
                </a>
              </span>
            </>
          )}
        </div>
        <div className="catalog-content-block-2">
          <h3 className="catalog-mini-заголовок-text"></h3>
        </div>
        <div className="catalog-content-block-3">
          <h2 className="catalog-content-заголовок">
            {selectedCategory ? categories.find(cat => cat.id === selectedCategory)?.name : 'Выберите категорию'}
          </h2>
        </div>
        <div className="catalog-content-tovar">
          <div className="catalog-content-tovar-list">
            {products.map(product => (
              <CardProduct key={product.id} product={product} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Catalog;
